import * as ng from 'angular';
import { TradersYardApi } from '../../models/api';

// TODO: move to some popup opening service
function getCheckoutWindowOptions(width: number, height: number) {
    const topPos = window.screenTop;
    const leftPos = window.screenLeft + window.innerWidth / 2 - width;
    return `width=${width},height=${height},top=${topPos},left=${leftPos},toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no`;
}

const CHECKOUT_WINDOW_TARGET = 'tradersyard-checkout';

export default (module: ng.IModule) => {
    module.component('tyCheckoutSteps', {
        bindings: {
            order: '<',
            onPaid: '&?',
        },
        template: require('./checkout-steps.html').default,
        controller: CheckoutStepsCtrl,
    });
};

// TODO: move to service
function _isOrderPaid(remoteOrder: { status: string }): boolean {
    return [
        TradersYardApi.xYards.xYardsOrderStatus.PROCESSING,
        TradersYardApi.xYards.xYardsOrderStatus.COMPLETED,
    ].includes(remoteOrder.status as TradersYardApi.xYards.xYardsOrderStatus);
}

/**
 * Handles checkout steps for an Order. The order needs to be created first by an outside process.
 * You can create Orders for Groups and Webinars using their respective API endpoints.
 */
class CheckoutStepsCtrl implements ng.IComponentController {
    static $inject = ['$http', '$window', '$timeout', '$socket'];
    order?: TradersYardApi.xYards.xYardsOrder;
    /**
     * Handle to the checkout popup window. We want to close it when order is paid.
     * TODO: embed an iframe instead of using a separate popup window.
     * @private
     */
    private checkoutWindow: Window | null = null;
    /**
     * Different views we can show in the modal. Kind of a router :)
     * @private
     */
    private view: 'pending' | 'success' = 'pending';

    constructor(
        private $http: ng.IHttpService,
        private $window: ng.IWindowService,
        private $timeout: ng.ITimeoutService,
        private $socket: any
    ) {}

    $onInit() {
        this.$socket.on('xy:order.status_change', (socketData: { order_key: string; status: string }) => {
            if (this.order?.ty_order_key !== socketData.order_key) return;

            this.order.status = socketData.status as TradersYardApi.xYards.xYardsOrderStatus;

            if (_isOrderPaid(socketData)) this._onOrderPaid();
        });

        this._openCheckoutUrl(this.order!);
    }

    private _onOrderPaid() {
        this.view = 'success';
        this.checkoutWindow?.close();

        // TODO: we should move this outside of the checkout process and call `onPaid` event.
        this.$timeout(() => {
            // when order is paid, reload the page after moment. The user should now be part of the group.
            window.location.reload();
        }, 2000);
    }

    focusCheckoutWindow() {
        const checkoutClosed = this.checkoutWindow?.closed ?? true;

        if (!checkoutClosed) {
            // if window is not closed, just try to focus it.
            this.checkoutWindow?.focus();
        } else if (this.order) {
            // the window might be closed, but we might have the order details, so just open the checkout page
            this._openCheckoutUrl(this.order);
        } else {
            // should no happen, but yeah... no order was found, just go back to checkout view
            // this.view = 'checkout';
        }
    }

    private _openCheckoutUrl(order: TradersYardApi.xYards.xYardsOrder) {
        const windowOptions = getCheckoutWindowOptions(1000, 1000);
        this.checkoutWindow = this.$window.open(order.checkout_url, CHECKOUT_WINDOW_TARGET, windowOptions);
        this.view = 'pending';
    }
}
